import { PaziaTab, PaziaTabs } from "components/atoms";
import { routes } from "consts";
import React from "react";
import { useLocation } from "react-router-dom";
import { removeTrailingSlash } from "utils/urlUtils";

interface StudentTabsProps {
  studentId: number;
  courseId: number;
}

export const StudentTabs = ({ studentId, courseId }: StudentTabsProps) => {
  const location = useLocation();

  const checkLocationPathName = (path: string) => {
    return removeTrailingSlash(location.pathname) === removeTrailingSlash(path);
  };

  const tabs: PaziaTab[] = [
    {
      name: "Podstawowe",
      active: checkLocationPathName(routes.STUDENT_NESTED.COURSES(studentId, courseId)),
      link: routes.STUDENT_NESTED.COURSES(studentId, courseId),
    },
    {
      name: "Płatności",
      active: checkLocationPathName(routes.STUDENT_NESTED.PAYMENTS(studentId, courseId)),
      link: routes.STUDENT_PAYMENTS,
    },
    {
      name: "Akcje",
      active: checkLocationPathName(routes.STUDENT_NESTED.ACTIONS(studentId, courseId)),
      link: routes.STUDENT_ACTIONS,
    },
  ];

  return (
    <div className="border-b border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-800">
      <PaziaTabs tabs={tabs} className="px-4" />
    </div>
  );
};
